import React from "react";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    text: {
        color: "#D9D9D9",
        fontFamily: "Inter, sans-serif",
        fontSize: "0.875rem",
        fontWeight: 400,
        margin: 0,
        padding: 0,
        lineHeight: 1.4,
    }
})

export const SectionTitle = ({show, children}) => {
    const classes = useStyles()
    if(show) {
        return (
            <h5 className={classes.text}>
                {children}
            </h5>
        )
    } else {
        return null
    }
}